import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

//export const getNotesList = () => httpClient.get(apis.GET_NOTES_LIST);
export const getNotesBooksList = () => httpClient.get(apis.GET_NOTES_BOOKS_LIST);
//export const generateFile = ({ course_id }) =>
//    httpClient.get(`${apis.DOWNLOAD_NOTE}${course_id}`);
//export const generateFileRft = ({ course_id, bookIds }) =>
//    httpClient.get(`${apis.DOWNLOAD_NOTE_RFT}${course_id}`, {
//        params: { bookIds },
//    });
